import React, { useEffect, useState } from 'react';
import ticketService from '../../services/ticketService';
import RecordCreationFields from './RecordCreationFields';

const RecordUpdateFields = ({ value, onChange, disabled = false, lockRecord = false }) => {
  const [modules, setModules] = useState([]);
  const [records, setRecords] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    ticketService.getRecordCreationOptions('update').then(result => {
      if (!active) return;
      if (result.success) setModules(result.data);
      else setError(result.message || 'Unable to load modules.');
    });
    return () => { active = false; };
  }, []);
  useEffect(() => {
    if (!value.module || lockRecord) return undefined;
    let active = true;
    setRecords([]);
    setLoading(true);
    const timer = setTimeout(() => {
      ticketService.getUpdateRecords({ module: value.module, search }).then(result => {
        if (!active) return;
        if (result.success) { setRecords(result.data); setError(''); }
        else setError(result.message || 'Unable to load records.');
        setLoading(false);
      });
    }, 250);
    return () => { active = false; clearTimeout(timer); };
  }, [value.module, search, lockRecord]);
  const selectRecord = async recordId => {
    if (!recordId) { onChange({ module: value.module, data: {} }); return; }
    setLoading(true);
    const result = await ticketService.getUpdateRecord(recordId, value.module);
    setLoading(false);
    if (result.success) { onChange(result.data); setError(''); }
    else setError(result.message || 'Unable to load record.');
  };
  const selected = modules.find(option => option.value === value.module);
  return <div className="ticket-create-form">
    {!lockRecord && <>
      <label>Module
        <select className="input" value={value.module || ''} disabled={disabled || loading} onChange={event => { setSearch(''); onChange({ module: event.target.value, data: {} }); }}>
          <option value="">Select module</option>
          {modules.map(option => <option key={option.value} value={option.value}>{option.label}</option>)}
        </select>
      </label>
      {value.module && <>
        <label>Search records<input className="input" value={search} onChange={event => setSearch(event.target.value)} disabled={disabled} /></label>
        <label>Record to update
          <select className="input" value={value.record_id || ''} disabled={disabled || loading} onChange={event => selectRecord(event.target.value)}>
            <option value="">{loading ? 'Loading…' : 'Select record'}</option>
            {value.record_id && !records.some(record => record._id === value.record_id) && <option value={value.record_id}>{value.record_label || value.record_id}</option>}
            {records.map(record => <option key={record._id} value={record._id}>{[record.code || record.merchant_code || record.currency_code, record.name].filter(Boolean).join(' — ') || record._id}</option>)}
          </select>
        </label>
      </>}
    </>}
    {error && <p role="alert" className="ticket-inline-notice is-error">{error}</p>}
    {value.record_id && selected && <RecordCreationFields level="update" lockModule grouped={value.module !== 'merchants'} value={value} disabled={disabled || loading}
      onChange={next => onChange({ ...value, data: Object.fromEntries(Object.entries(next.data).filter(([key]) => selected.fields.some(field => field.key === key))) })} />}
  </div>;
};
export default RecordUpdateFields;
